export const formatMoneyArs = (value) => value === null || value === undefined
  ? "No disponible"
  : new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }).format(Number(value));

export const formatDateAr = (value) => {
  const [year, month, day] = String(value || "").slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : "—";
};

export const labelEstado = (value) => ({
  NO_VALIDADO: "Pendiente de validación",
  SIN_REGLA_VERIFICABLE: "Falta aprobar una tasa",
  REINGRESO_PENDIENTE: "Operación programada para otro lote",
  OPERACIONES_SIN_PROCESAR: "Operaciones que requieren revisión",
  LISTA_PARA_REVISION: "Lista para revisión",
  CON_PENDIENTES: "Con pendientes",
  TEMPORAL_CALCULADA: "Cálculo completo",
  TEMPORAL_CALCULADA_CON_BLOQUEOS: "Cálculo con pendientes",
  COINCIDE: "Coincide con el histórico",
  CON_DIFERENCIAS: "Con diferencias",
  INCOMPLETO: "Requiere completar datos",
  SIN_TXT: "Falta comparar el archivo bancario",
  SIN_HISTORICO: "Sin histórico para comparar",
  BORRADOR: "Borrador",
  SIMULADO: "Simulada",
  PENDIENTE_APROBACION: "Pendiente de aprobación",
  APROBADO_PARA_PRUEBAS: "Aprobada para pruebas",
  RECHAZADO: "Rechazada",
  PENDIENTE: "Pendiente",
  EN_APROBACION: "Pendiente de aprobación",
  INFORMATIVA: "Para seguimiento",
}[value] || String(value || "Sin estado").replaceAll("_", " "));

export const textoPresentacion = (value) => String(value || "")
  .replaceAll("NO_VALIDADO", "Pendiente de validación")
  .replaceAll("SIN_REGLA_VERIFICABLE", "Falta aprobar una tasa")
  .replaceAll("REINGRESO_PENDIENTE", "Operación programada para otro lote")
  .replaceAll("OPERACIONES_SIN_PROCESAR", "Operaciones que requieren revisión")
  .replaceAll("PENDIENTE_APROBACION", "Pendiente de aprobación")
  .replaceAll("APROBADO_PARA_PRUEBAS", "Aprobada para pruebas");

export const statusClass = (value) => value === "COINCIDE" ? "pagos-status--safe"
  : ["CON_PENDIENTES", "CON_DIFERENCIAS", "INCOMPLETO"].includes(value) ? "pagos-status--danger"
    : "pagos-status--pending";
